import * as filtersHelper from "@/helpers/filters.helper"
import { CheckboxInlineFilter } from "@/organisms/FilterNew/CheckboxInlineFilter"

import type { ItemType } from "@/atoms"
import type { TFunction } from "@/hooks/useTranslation"

export const ActivityGroupIssueStatus = (
  t: TFunction,
  menuItems?: ItemType[],
  placement: string = "ActivityGroupIssueStatus"
) => {
  const hasActionFilter = filtersHelper.getHasActionFilter(t)
  const resolvedInScopeFilter = filtersHelper.getResolvedInScopeFilter(t)
  const resolvedInCodeRepoFilter = filtersHelper.getResolvedInCodeRepoFilter(t)

  return [
    ...(menuItems
      ? [
          {
            key: "issueStatus_Group",
            type: "group" as const,
            label: "Status",
            children: menuItems
          }
        ]
      : []),
    {
      key: "activityIssueStatus_Group",
      label: "Activity",
      type: "group" as const,
      children: [
        {
          label: (
            <CheckboxInlineFilter
              keyFilter={hasActionFilter.key}
              placement={placement}
            >
              Has Action
            </CheckboxInlineFilter>
          ),
          key: hasActionFilter.key
        },
        {
          label: (
            <CheckboxInlineFilter
              keyFilter={resolvedInScopeFilter.key}
              placement={placement}
            >
              Resolved In Scope
            </CheckboxInlineFilter>
          ),
          key: resolvedInScopeFilter.key
        },
        {
          label: (
            <CheckboxInlineFilter
              keyFilter={resolvedInCodeRepoFilter.key}
              placement={placement}
            >
              Resolved In Code Repository
            </CheckboxInlineFilter>
          ),
          key: resolvedInCodeRepoFilter.key
        }
      ]
    }
  ]
}
